import { ui } from '@wp-g2/styles';
import { noop } from '@wp-g2/utils';
import React from 'react';
import { CloseButton } from '../CloseButton';
import * as styles from './Tag.styles';
var RemoveButtonView = styles.RemoveButtonView;

function TagRemoveButton(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
      removeButtonText = _ref.removeButtonText;
  if (!removeButtonText) return null;
  return /*#__PURE__*/React.createElement(RemoveButtonView, ui.$('TagRemoveButtonWrapper'), /*#__PURE__*/React.createElement(CloseButton, Object.assign({
    "aria-label": removeButtonText,
    currentColor: true,
    iconSize: 12,
    onClick: onClick,
    size: "xSmall",
    title: removeButtonText,
    variant: "tertiary"
  }, ui.$('TagRemoveButton'))));
}

export default /*#__PURE__*/React.memo(TagRemoveButton);